import React, { Component } from 'react';
import moment from 'moment';

import { checkDateHasProgram, scrollGridToTarget } from '@tvguide/helpers';

class DateElement extends Component {
  constructor(props) {
    super(props);
  }

  goToTargetDate(e) {
    const date = e.currentTarget.dataset.targetDay;
    const hours = new Date().getHours();
    const time = `${hours >= 10 ? hours : `0${hours}`}:00:00`;
    scrollGridToTarget(document.querySelector(`[data-time="${date} ${time}"]`));
  }

  changeTargetDay(e) {
    const targetDate = e.currentTarget.dataset.targetDay;
    this.props.selectDay(targetDate);
    if (!checkDateHasProgram(targetDate)) {
      this.props.getDayProgram(targetDate);
    }
  }

  handleClick(e) {
    switch (this.props.view) {
      case 'text':
        this.changeTargetDay(e);
        break;
      case 'list':
        this.changeTargetDay(e);
        break;
      case 'grid':
        this.goToTargetDate(e);
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <li
        data-target-day={this.props.date.format('YYYY-MM-DD')}
        className={
          moment(this.props.date).isSame(this.props.activeDay, 'day')
            ? 'active'
            : ''
        }
        onClick={this.handleClick.bind(this)}
      >
        <button>
          <span>
            {moment().isSame(this.props.date, 'day')
              ? 'Today'
              : this.props.date.format('ddd')}
          </span>
          {this.props.date.format('D')}
        </button>
      </li>
    );
  }
}

export default DateElement;
